import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { DownloadService } from 'src/modules/base/shared/services/download.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { DialogConfig } from '../../dialog/dialog-config';
import { DialogRef } from '../../dialog/dialog-ref';

@Component({
    selector: 'app-download-info',
    templateUrl: './download-info.component.html',
    styles: ['#download_area{ padding:10px;}'],
    standalone: false
})
export class DownloadInfoComponent implements OnInit {
  public interval:any = false;
  constructor(public loader:LoaderService, public dialog: DialogRef,public downloadService:DownloadService,public dialogConfig: DialogConfig) { }

  ngOnInit() {
    if(this.dialogConfig.data.showLoader){
      this.loader.showSpinner();
    }
  }
  ngOnDestroy(){
    this.loader.hideSpinner();
  }
}
